export const FEATURE_NAME = 'projects';

export const LIST = 'list';
export const FILTERS = 'filters';
